import { gql } from '@apollo/client'

const GET_NONPROFIT_BY_ID = gql`
  query GetNonprofitById($id: Int!) {
    getNonprofitOrg(id: $id) {
      id
      name
      missionStatement
      disabled
      formationPlan
      platformPlan
      ein
      legalName
      websiteUrl
      isFiscallySponsored
      isTest
      state
      yearEstablished
      createdAt
      updatedAt
      disabledAt
      hasProfile
      funders {
        id
        name
      }
      cohorts {
        id
        name
      }
      users {
        id
        email
        firstName
        lastName
        role
      }
    }
  }
`

export default GET_NONPROFIT_BY_ID
